import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import config from 'constants/config'
import { useIsBannerHidden } from 'hooks/useIsBannerHidden'
import ContactOptionsBanner from '../Header/HeaderBanners/ContactOptionsBanner'
import HeaderTopBanners from '../Header/HeaderTopBanners'

function BannerRoutes() {
  const isHidden = useIsBannerHidden('headerTopBanners')

  if (isHidden) return null

  return <>
    {config.SHOW_CONTACT_BANNER && !config.NAVKIT_NAVBAR_ENABLED && <CSSBreakpoint max="mobile">
      <ContactOptionsBanner />
    </CSSBreakpoint>}
    <HeaderTopBanners />
  </>
}

export default BannerRoutes
